
// eslint-disable-next-line no-unused-vars
/**
 * 二分法寻找出现位置
 * @param {Array} arr 数组容器
 * @param {Object} obj 寻找对象
 * @param {*} key 寻找key字段
 * @returns 返回寻找的位置
 */
function binarySearch (arr, obj, key) {
  let low = 0
  let high = arr.length - 1
  while (low <= high) {
    var mid = Math.floor((low + high) / 2)
    if (obj[key] === arr[mid][key]) {
      return mid
    } else if (obj[key] < arr[mid][key]) {
      low = mid + 1
    } else {
      high = mid - 1
    }
  }
  return low
}

/**
 * 排序插入
 * @param {Array} arr 列表数据容器
 * @param {Object} obj 插入数据内容
 * @param {*} sortedKey 排序KEY
 */
export function sortedAdd (arr, obj, sortedKey) {
  if (!arr || !obj || !sortedKey) return false
  if (arr.length === 0) {
    arr.push(obj)
    return true
  }
  // 二分法插入
  let idx = binarySearch(arr, obj, sortedKey)
  arr.splice(idx, 0, obj)
  return true
}

/**
 * 把列表转换成Tree结构
 * @param {Array} arr 原始数据
 * @param {*} parentKey 父KEY
 * @param {*} sortedKey 排序KEY
 */
export function sortedTree (arr, parentKey, sortedKey) {
  if (!arr || !parentKey || !sortedKey) return []
  let dataMap = {}
  let retRoot = []
  arr.forEach(item => {
    dataMap[item['id']] = item
  })

  arr.forEach(item => {
    if (item[parentKey] === -1) {
      sortedAdd(retRoot, item, sortedKey)
    } else {
      let parentItem = dataMap[item[parentKey]]
      if (parentItem) {
        if (!parentItem['children']) {
          parentItem['children'] = []
        }
        sortedAdd(parentItem['children'], item, sortedKey)
      }
    }
  })
  return retRoot
}



// WEBPACK FOOTER //
// ./src/libs/utils/array-utils.js